import React from "react";

import { useLoading } from "../../context/loadingContext";

const Loader = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;
  else
    return (
      <div className="flex items-center justify-center w-screen h-screen absolute bg-black/10 z-[99999]">
        <div class="loading-container">
          <div class="loading-text">
            <span>С</span>
            <span>M</span>
            <span>A</span>
            <span>Р</span>
            <span>Т</span>
            <span>Б</span>
            <span>И</span>
            <span>Л</span>
            <span>Л</span>
            <span>И</span>
            <span>Н</span>
            <span>Г</span>
          </div>
        </div>
        {/* <div className='loaderBody'>
            <div></div>
            <div></div>
            <div></div>
              <Title level={3} style={{ color: '#46CE7C', margin: 0 }}>SMARTPAY</Title> <TypeWriter data={typeWriter}/>
            </div> */}
      </div>
    );
};

export default Loader;
